import React, { useState, useEffect } from 'react'
import { ButtonHLPure, ButtonAddHLPure, SearchBarHLPure, DropDownBtnHLPure, GridSelectionHLPure, DialogPdfHLPure, InputHLPure, InstructionsPure, InteractiveDialog, CheckBoxHLPure, ButtonTrashHLPure, LabelErrorPure, LabelModalPure, DialogSystemGLPure } from '../../pures'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import { useMediaQuery } from '@material-ui/core'

const HeaderColumns = (props) => {
  const { t, title } = props
  return <span className={(title === t('administrationTypeDocumentDataProfile.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{title}</span>
}

const CellColumnName = (props) => {
  const { dataItem, t } = props
  const completeDate = `${t('administrationTypeDocumentDataProfile.grid.modified.date')} ${dataItem.modifyDate || ''}`

  return (
    <td>
      <div className='grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{dataItem.name}{(dataItem.mandatory) ? ' *' : ''}</p>
        <p className='grid-cell-subtitles'>{completeDate}</p>
      </div>
    </td>
  )
}

const CellColumnText = (props) => {
  const { dataItem, col, t } = props
  const ENV = process.env
  let content = ''

  if (col === 2) {
    if (dataItem.type === ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT) content = t('administrationTypeDocumentDataProfile.grid.type.data.text')
    if (dataItem.type === ENV.REACT_APP_DATA_TYPE_VARIABLES_NUMBER) content = t('administrationTypeDocumentDataProfile.grid.type.data.number')
    if (dataItem.type === ENV.REACT_APP_DATA_TYPE_VARIABLES_DATE) content = t('administrationTypeDocumentDataProfile.grid.type.data.date')
    if (dataItem.type === ENV.REACT_APP_DATA_TYPE_VARIABLES_SELECTOR) content = t('administrationTypeDocumentDataProfile.grid.type.data.selector')
    if (dataItem.type === ENV.REACT_APP_DATA_TYPE_VARIABLES_BOOLEAN) content = t('administrationTypeDocumentDataProfile.grid.type.data.logical')
  }

  if (col === 3) {
    if (dataItem.formatVariableKey === ENV.REACT_APP_FORMAT_VARIABLES_KEY_LOGIC) content = t('administrationTypeDocumentDataProfile.grid.format.logical')
    else if (dataItem.formatVariableKey === ENV.REACT_APP_FORMAT_VARIABLES_KEY_SELECTOR) content = t('administrationTypeDocumentDataProfile.grid.format.selector')
    else content = dataItem.format
  }

  if (col === 4) {
    if (dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_CONTRACT) content = t('configuration.AdministrationTypeDocuments.data.profile.contract')
    if (dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_IDS) content = t('configuration.AdministrationTypeDocuments.data.profile.ids')
    if (dataItem.dataProfile === ENV.REACT_APP_TYPE_DOCUMENT_DATA_PROFILE_KEY_PROOF_OF_ADDRESS) content = t('configuration.AdministrationTypeDocuments.data.profile.proofOfAddress')
  }

  return (
    <td>
      <div>
        <p className='grid-cell-subtitles'>{content}</p>
      </div>
    </td>
  )
}

const CellColumnBtns = (props) => {
  const { t, dataItem, handleShowModalAddDetails, handleShowModalDelete } = props
  return (
    <td>
      <div className='grid-btn-div'>
        <button className='grid-btn-action' onClick={() => handleShowModalAddDetails(dataItem)}>
          <p>{t('administrationTypeDocumentDataProfile.grid.btns.details')}</p>
        </button>
        <ButtonTrashHLPure openDelay={600} onClickBtn={() => handleShowModalDelete(dataItem)} />

      </div>
      <div className='grid-btn-arrow' onClick={() => handleShowModalAddDetails(dataItem)}>
        <img alt='assemblies-arrow' src={ArrowBtnMobile} />
      </div >
    </td >
  )
}

export const dataTypeOptions = [
  {
    id: 1,
    name: 'questionnairesAdministrationEditQuestionView.drop.format.labels.text',
    key: process.env.REACT_APP_DATA_TYPE_VARIABLES_TEXT,
  },
  {
    id: 2,
    name: 'questionnairesAdministrationEditQuestionView.drop.format.labels.ammount',
    key: process.env.REACT_APP_DATA_TYPE_VARIABLES_NUMBER
  },
  {
    id: 3,
    name: 'questionnairesAdministrationEditQuestionView.drop.format.labels.date',
    key: process.env.REACT_APP_DATA_TYPE_VARIABLES_DATE,
  },
  {
    id: 4,
    name: 'questionnairesAdministrationEditQuestionView.drop.format.labels.logic',
    key: process.env.REACT_APP_DATA_TYPE_VARIABLES_BOOLEAN
  }
]

/**
 * @typedef {Object} Props
 * @property {Function} t Funtion to translate
 * @property {Function} handleCancel Function to back page
 * @property {{}} typeDocumentSelected Type document selected
 * @property {[{}]} formatVariables All the formats that variables can have
 * @property {Function} handleSumbitVariable Function to create or update variable
 * @property {Function} handleDeleteVariable Function to delete variable
 * @param {Props}
 * @return {JSX.Element} 
 */
const AdministrationTypeDocumentDataProfile = ({ t, handleCancel, typeDocumentSelected, formatVariables, handleSumbitVariable, handleDeleteVariable }) => {

  const ENV = process.env

  const filterOptions = [
    {
      name: t('administrationTypeDocumentDataProfile.filter.all'),
      key: 'all',
      id: 1
    },
    {
      name: t('administrationTypeDocumentDataProfile.filter.data.profile'),
      key: 'dataProfile',
      id: 2
    },
    {
      name: t('administrationTypeDocumentDataProfile.filter.custom'),
      key: 'custom',
      id: 3
    }
  ]

  const dataTypeOptions = [
    {
      id: 1,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.text'),
      key: ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT,
    },
    {
      id: 2,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.ammount'),
      key: ENV.REACT_APP_DATA_TYPE_VARIABLES_NUMBER
    },
    {
      id: 3,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.date'),
      key: ENV.REACT_APP_DATA_TYPE_VARIABLES_DATE,
    },
    {
      id: 4,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.logic'),
      key: ENV.REACT_APP_DATA_TYPE_VARIABLES_BOOLEAN
    },
    {
      id: 5,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.selector'),
      key: ENV.REACT_APP_DATA_TYPE_VARIABLES_SELECTOR
    }
  ]

  const is1200 = useMediaQuery('(max-width:1200px)')
  const is960 = useMediaQuery('(max-width:960px)')
  const is820 = useMediaQuery('(max-width:820px)')
  const is620 = useMediaQuery('(max-width:620px)')
  const is560 = useMediaQuery('(max-width:560px)')

  const [searchValue, setSearchValue] = useState('')
  const [filterValue, setFilterValue] = useState(1)
  const [variablesGrid, setVariablesGrid] = useState([])
  const [customDataSelected, setCustomDataSelected] = useState(null)
  const [showModalAddDetails, setShowModalAddDetails] = useState(false)
  const [modalMode, setModalMode] = useState('add')
  const [variableName, setVariableName] = useState('')
  const [dataTypeSelected, setDataTypeSelected] = useState(ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT)
  const [formatSelected, setFormatSelected] = useState(ENV.REACT_APP_FORMAT_VARIABLES_KEY_SIMPLE_TEXT)
  const [mandatory, setMandatory] = useState(true)
  const [formatOptions, setFormatOptions] = useState([])
  const [errorVariableName, setErrorVariableName] = useState(false)
  const [showModalDelete, setShowModalDelete] = useState(false)

  const AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  const CellColumnOne = (props) => <CellColumnName {...props} t={t} />
  const CellColumnTwo = (props) => <CellColumnText {...props} t={t} col={2} />
  const CellColumnThree = (props) => <CellColumnText {...props} t={t} col={3} />
  const CellColumnFour = (props) => <CellColumnText {...props} t={t} col={4} />
  const CellColumnFive = (props) => <CellColumnBtns {...props} t={t} handleShowModalAddDetails={handleShowModalAddDetails} handleShowModalDelete={handleShowModalDelete} />

  useEffect(() => {
    if (!typeDocumentSelected) return

    const variables = typeDocumentSelected.variables || []
    setVariablesGrid(variables)
  }, [typeDocumentSelected])

  useEffect(() => {
    if (!showModalAddDetails || !formatVariables || formatVariables.length === 0) return

    let name = ''
    let isRequired = false
    let groupName = ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT
    let formatVariableKeySelected = ENV.REACT_APP_FORMAT_VARIABLES_KEY_SIMPLE_TEXT
    let dataTypeKey = groupName
    let mandatorySelected = false

    if (customDataSelected) {
      name = customDataSelected.variableName || ''
      isRequired = customDataSelected.mandatory || false
      const formatVarBD = formatVariables.find(fv => { return fv.key === customDataSelected.formatVariableKey })
      groupName = formatVarBD.groupName || ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT
      formatVariableKeySelected = formatVarBD.key || ENV.REACT_APP_FORMAT_VARIABLES_KEY_SIMPLE_TEXT
      dataTypeKey = (groupName === ENV.REACT_APP_FORMAT_VARIABLES_GROUP_NAME_LOGIC) ? ENV.REACT_APP_DATA_TYPE_VARIABLES_BOOLEAN : groupName
      mandatorySelected = customDataSelected.mandatory || false
    } else {
      const formatVarBD = formatVariables.find(fv => { return fv.key === formatVariableKeySelected })
      formatVariableKeySelected = formatVarBD.key || ENV.REACT_APP_FORMAT_VARIABLES_KEY_SIMPLE_TEXT
    }

    const formatVariablesFilter = formatVariables.filter(fv => { return fv.groupName === groupName })

    setVariableName(name)
    setMandatory(isRequired)
    setFormatOptions(formatVariablesFilter)
    setFormatSelected(formatVariableKeySelected)
    setDataTypeSelected(dataTypeKey)
    setMandatory(mandatorySelected)
  }, [formatVariables, showModalAddDetails])

  useEffect(() => {
    let copyVariables = [...typeDocumentSelected.variables] || []
    if (filterValue === 2) copyVariables = copyVariables.filter(item => { return item.dataProfile })
    if (filterValue === 3) copyVariables = copyVariables.filter(item => { return !item.dataProfile })

    const newDataGrid = copyVariables.filter(item => { return item.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 })
    setVariablesGrid(newDataGrid)
  }, [searchValue, filterValue])

  const handleChangeName = (e) => {
    const value = e.target.value
    setVariableName(value)
    setErrorVariableName(false)
  }

  const handleSearch = (e) => {
    const value = e.target.value
    setSearchValue(value)
  }

  const handleSetFilter = (e) => {
    let value = e.target.value
    value = Number(value) || 1
    setFilterValue(value)
  }

  const handleShowModalAddDetails = (customData) => {
    setCustomDataSelected(customData)
    setModalMode(customData ? 'edit' : 'add')
    setShowModalAddDetails(true)
  }

  const handleCloseModalAddDetails = () => {
    setShowModalAddDetails(false)
    cleanData()
  }

  const handleChangeDataType = (e) => {
    const value = e.target.value
    let groupName = value || ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT
    if (value === ENV.REACT_APP_DATA_TYPE_VARIABLES_BOOLEAN) groupName = ENV.REACT_APP_FORMAT_VARIABLES_GROUP_NAME_LOGIC
    const formatVariablesFilter = formatVariables.filter(fv => { return fv.groupName === groupName })
    const formatVariableKeySelected = (formatVariablesFilter && formatVariablesFilter.length > 0) ? formatVariablesFilter[0].key : ENV.REACT_APP_FORMAT_VARIABLES_KEY_SIMPLE_TEXT
    setFormatOptions(formatVariablesFilter)
    setFormatSelected(formatVariableKeySelected)
    setDataTypeSelected(value)
  }

  const cleanData = () => {
    setCustomDataSelected(null)
    setVariableName('')
    setDataTypeSelected(ENV.REACT_APP_DATA_TYPE_VARIABLES_TEXT)
    setFormatSelected(ENV.REACT_APP_FORMAT_VARIABLES_KEY_SIMPLE_TEXT)
    setMandatory(false)
  }

  const handleShowModalDelete = (customData) => {
    setCustomDataSelected(customData)
    setShowModalDelete(true)
  }

  const handleCloseModalDelete = () => {
    setShowModalDelete(false)
    setCustomDataSelected(null)
  }

  const handleSubmitModal = (e) => {
    e.preventDefault()
    const data = {
      view: (customDataSelected && customDataSelected.id) ? 'update' : 'create',
      variableId: (customDataSelected && customDataSelected.id) ? customDataSelected.id : null,
      typeDocumentSelectId: typeDocumentSelected.id,
      variableName,
      dataProfile: (customDataSelected && customDataSelected.dataProfile) ? customDataSelected.dataProfile : null,
      typeData: dataTypeSelected,
      formatVariableKey: formatSelected,
      mandatory
    }
    handleSumbitVariable({ data, handleCloseModalAddDetails, cleanData, setErrorVariableName, variables: typeDocumentSelected.variables || [], setVariablesGrid })
  }

  const handleSubmiModalDelete = () => {
    const paramsDelete = {
      variable: customDataSelected,
      handleCloseModalDelete,
      setVariablesGrid
    }

    handleDeleteVariable(paramsDelete)
  }

  let widthCellOne = '120px'
  let widthCellTwo = '60px'
  let widthCellThree = '80px'
  let widthCellFour = '60px'
  let widthCellSix = '60px'

  if (is1200) {
    widthCellSix = '80px'
  }

  if (is620) {
    widthCellSix = '100px'
  }

  if (is560) {
    widthCellSix = '30px'
  }

  return (
    <div className='administrationTypeDocumentDataProfile-container'>
      <div className='administrationTypeDocumentDataProfile-navbar'>
        <ButtonAddHLPure
          iconAdd
          onClickBtn={() => handleShowModalAddDetails(null)}
          nameBtn={t('administrationTypeDocumentDataProfile.btns.add.data')}
        />
        <SearchBarHLPure
          searchValue={searchValue}
          onSearchChange={(e) => handleSearch(e)}
          placeholder={t('administrationTypeDocumentDataProfile.search.placeholder')}
        />
        <div className='administrationTypeDocumentDataProfile-filter'>
          <DropDownBtnHLPure
            iconFilter
            valueItem='id'
            nameOption='name'
            optionsValue={filterValue}
            optionsDropDown={filterOptions}
            onDropDownChange={(e) => handleSetFilter(e)}
          />
        </div>
      </div>
      <div className='administrationTypesOfDocumentsView-grid'>
        <GridSelectionHLPure
          skip={0}
          take={6}
          dataGrid={variablesGrid}

          columnOne={true}
          titleRow1={t('administrationTypeDocumentDataProfile.grid.title.1')}
          cellColumnOne={CellColumnOne}
          headerColumnOne={AllHeadersColumns}
          widthColumnOne={widthCellOne}
          minResizableWidth1={'auto'}

          columnTwo={(is560) ? false : true}
          titleRow2={t('administrationTypeDocumentDataProfile.grid.title.2')}
          cellColumnTwo={CellColumnTwo}
          headerColumnTwo={AllHeadersColumns}
          widthColumnTwo={widthCellTwo}
          minResizableWidth2={widthCellTwo}

          columnThree={(is820) ? false : true}
          titleRow3={t('administrationTypeDocumentDataProfile.grid.title.3')}
          cellColumnThree={CellColumnThree}
          headerColumnThree={AllHeadersColumns}
          widthColumnThree={widthCellThree}
          minResizableWidth3={widthCellThree}

          columnFour={(is960) ? false : true}
          titleRow4={t('administrationTypeDocumentDataProfile.grid.title.4')}
          cellColumnFour={CellColumnFour}
          headerColumnFour={AllHeadersColumns}
          widthColumnFour={widthCellFour}
          minResizableWidth4={widthCellFour}

          columnSix={true}
          titleRow6={t('administrationTypeDocumentDataProfile.grid.title.6')}
          cellColumnSix={CellColumnFive}
          headerColumnSix={AllHeadersColumns}
          widthColumnSix={widthCellSix}
          minResizableWidth6={widthCellSix}
        />
      </div>
      <div className='administrationTypeDocumentDataProfile-btns'>
        <ButtonHLPure
          onClickBtn={handleCancel}
          nameBtn={t('button.return')}
        />
      </div>

      {showModalAddDetails && (
        <InteractiveDialog
          title={modalMode === 'edit'
            ? t('administrationTypeDocumentDataProfile.modal.title.edit')
            : t('administrationTypeDocumentDataProfile.modal.title.add')}
          saveBtnTitle={t('button.save')}
          cancelBtnTitle={t('button.cancel')}
          onClose={() => handleCloseModalAddDetails(false)}
          onSave={(e) => handleSubmitModal(e)}
        >
          <div className='administrationTypeDocumentDataProfile-modal'>
            <InstructionsPure instructions={t('administrationTypeDocumentDataProfile.modal.title.description')} />
            <InputHLPure
              labelInput={t('administrationTypeDocumentDataProfile.modal.name')}
              valueInput={variableName}
              characterLimit={128}
              inputActive
              typeInput='text'
              handleChangeInput={(e) => handleChangeName(e)}
            />
            {
              errorVariableName && (<LabelErrorPure label={t('registration.validator.nameValidator')} />)
            }
            <DropDownBtnHLPure
              required
              tooltipShow
              valueItem={'key'}
              nameOption={'name'}
              optionsValue={dataTypeSelected}
              optionsDropDown={dataTypeOptions}
              onDropDownChange={(e) => handleChangeDataType(e)}
              labelDropDown={t('administrationTypeDocumentDataProfile.modal.data.type')}
              disable={modalMode === 'edit'}
            />
            <DropDownBtnHLPure
              required
              tooltipShow
              valueItem={'key'}
              nameOption={'format'}
              optionsValue={formatSelected}
              optionsDropDown={formatOptions}
              onDropDownChange={(e) => setFormatSelected(e.target.value)}
              labelDropDown={t('administrationTypeDocumentDataProfile.modal.format')}
              disable={modalMode === 'edit'}
            />
            <CheckBoxHLPure
              labelCheckBox={t('administrationTypeDocumentDataProfile.modal.required')}
              valueCheckBox={mandatory}
              checkedState={mandatory}
              onChangeHandler={(e) => setMandatory(e.target.checked)}
              disabled={modalMode === 'edit'}
            />
          </div>
        </InteractiveDialog>
      )
      }
      {
        showModalDelete && (
          <DialogSystemGLPure
            showConfirm={showModalDelete}
            confirmTitle={t('administrationTypeDocumentDataProfile.modal.title.delete')}
            labelCancelConfirmation={t('button.cancel')}
            labelSubmitConfirmation={t('button.delete')}
            confirmMessage={`${t('administrationTypeDocumentDataProfile.modal.delete.question')} ${customDataSelected?.variableName}?`}
            handleConfirmDeleteFlowClose={() => handleCloseModalDelete(false)}
            handleConfirmDeleteFlowSubmit={() => handleSubmiModalDelete()}
          />
        )
      }
    </div>
  )
}

export { AdministrationTypeDocumentDataProfile as default }